// SPDX-License-Identifier: Apache-2.0
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventHelper = void 0;
const enclave_1 = require("../enclave");
exports.EventHelper = {
    within(ms, eventEmitter, event) {
        let timeout;
        let cb = () => { };
        const res = new Promise((resolve, reject) => {
            timeout = setTimeout(reject, ms);
            cb = () => resolve(true);
            if (enclave_1.isEnclaveEvent(event)) {
                eventEmitter.on(event, cb);
            }
            else {
                eventEmitter.on(event, cb);
            }
        });
        return res.finally(() => {
            clearTimeout(timeout);
            if (enclave_1.isEnclaveEvent(event)) {
                eventEmitter.off(event, cb);
            }
            else {
                eventEmitter.off(event, cb);
            }
        });
    },
};
//# sourceMappingURL=event_helper.js.map